import './polyfills';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import { StyleSheetManager } from 'styled-components';
import { getDocumentRoot } from './utils/shadowDomHelper';
import { defineEventBusComponent } from './ksys-event-bus';

export function getCurrentScript() {
    const currentScript =
        document.currentScript ||
        (() => {
            const scripts = document.getElementsByTagName('script');
            const regex = /\/applicationManager\/apps\/(.*)\/main\.js$/;
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < scripts.length; i++) {
                const script = scripts[i];
                const match = regex.exec(script.src);
                if (match && match.length > 1) {
                    return script;
                }
            }
            return undefined;
        })();
    return currentScript;
}
export const CURRENT_SCRIPT = getCurrentScript() as HTMLScriptElement;

const root = getDocumentRoot();

const renderApp = intlSupported => {
    let src = '';
    if (CURRENT_SCRIPT) {
        src = (CURRENT_SCRIPT as HTMLScriptElement).src;
    }
    // Attach a shadow dom to the element
    const shadow = root.attachShadow({ mode: 'open' });
    // Create div element for react to render into
    const reactRoot = document.createElement('div');
    reactRoot.setAttribute('id', 'react-root');
    // Append react root to shadow root
    shadow.appendChild(reactRoot);
    // Create div element for the styles to render into
    const stylesRoot = document.createElement('div');
    stylesRoot.setAttribute('id', 'styles-root');
    shadow.appendChild(stylesRoot);

    Object.defineProperty(reactRoot, 'ownerDocument', { value: shadow });
    const methods = ['createElement', 'createElementNS', 'createTextNode'];
    for (const method of methods) {
        // @ts-ignore
        shadow[method] = (...args) => document[method](...args);
    }

    ReactDOM.render(
        // Set intlSupported prop
        // Spread data-attributes from root element as props
        // Pass script tag src as prop
        <StyleSheetManager target={stylesRoot}>
            <App
                intlSupported={intlSupported}
                scriptSrc={src}
                {...root.dataset}
                root={root}
            />
        </StyleSheetManager>,
        reactRoot
    );
};

// Dynamic import Intl polyfill
const loadIntlPolyfill = async () => {
    await import(/* webpackChunkName: "intl" */ 'intl');
};

export function getApplicationCode() {
    if (process.env.NODE_ENV === 'development') {
        return '0a4e3c39-ce22-47b2-9f6e-a92d662d1f2a';
    }
    const currentScript = CURRENT_SCRIPT;
    if (currentScript) {
        // tslint:disable-next-line: no-shadowed-variable
        const { src } = currentScript as any;
        const regex = /\/apps\/(.*)\/main\.js$/;
        const match = regex.exec(src);
        if (match && match.length > 1) {
            const [, applicationCode] = match;
            return applicationCode;
        }
    }
    return;
}

defineEventBusComponent();
// Load Intl polyfill where required then render app
if (!(window as any).Intl) {
    console.info('Intl API unsupported');
    loadIntlPolyfill();
    renderApp(false);
} else {
    console.info('Intl API supported');
    renderApp(true);
}



// WEBPACK FOOTER //
// ./src/index.tsx